import React from "react";
import { Link } from "react-router-dom";
import { Award, HeartHandshake, Leaf, ShieldCheck } from "lucide-react";

export default function AboutPage() {
  return (
    <div data-testid="about-page">
      <section className="welljio-soft-bg">
        <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16 text-center">
          <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-4">Our story</p>
          <h1 className="font-heading text-5xl sm:text-6xl font-bold tracking-tight leading-[1.05]">A brand built around how your body actually feels.</h1>
          <p className="text-lg text-welljio-muted leading-relaxed max-w-2xl mx-auto mt-6">
            Welljio was founded by a small team of physiotherapists and product designers in Hyderabad.
            We were tired of generic posture aids and uninspired wellness products — so we built a brand around evidence, craftsmanship and quiet luxury.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-14 grid lg:grid-cols-2 gap-12 items-center">
        <img src="https://images.pexels.com/photos/13538710/pexels-photo-13538710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Clinic" className="rounded-3xl object-cover w-full aspect-[4/3]"/>
        <div>
          <p className="text-xs uppercase tracking-widest text-welljio-subtle mb-3">Mission</p>
          <h2 className="font-heading text-4xl font-bold mb-5">Wellness should feel honest, beautiful and easy.</h2>
          <p className="text-welljio-muted leading-relaxed">
            Every Welljio product is designed with physiotherapists, manufactured with premium memory foam and natural fibers, and refined through hundreds of customer recovery stories. We believe relief shouldn't compromise on craft.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-4 gap-6">
        {[
          { i: Leaf, t: "OEKO-TEX fabrics", d: "Certified breathable and skin-friendly." },
          { i: Award, t: "ortho advised", d: "Designed with licensed therapists." },
          { i: HeartHandshake, t: "10,000+ relieved", d: "Customers across India and beyond." },
          { i: ShieldCheck, t: "30-day trust", d: "Returns + 1-year warranty." },
        ].map((b) => (
          <div key={b.t} className="bg-black border border-slate-100 rounded-3xl p-6">
            <div className="w-12 h-12 rounded-2xl bg-welljio-highlight text-welljio-accent flex items-center justify-center mb-4"><b.i className="w-5 h-5" strokeWidth={1.5}/></div>
            <h3 className="font-heading font-semibold">{b.t}</h3>
            <p className="text-sm text-welljio-muted mt-1">{b.d}</p>
          </div>
        ))}
      </section>

      <section className="max-w-3xl mx-auto px-6 py-14 text-center">
        <h2 className="font-heading text-4xl font-bold mb-4">Visit our wellness blog.</h2>
        <p className="text-welljio-muted mb-7">Posture guides, recovery routines and ergonomic essays.</p>
        <Link to="/blog" className="inline-block bg-welljio-ink text-white rounded-full px-7 py-4 font-medium hover:bg-slate-800">Read the blog</Link>
      </section>
    </div>
  );
}
